// Phone numbers: one shared format everywhere, (XXX) XXX-XXXX.
// Accepts typed or pasted numbers with +1, dashes, dots, spaces or parentheses.
// Stored as typed-and-formatted text; tel:/sms:/Quo already strip everything but digits and add +1.
export const phoneDigitsOnly = (value) => {
  let d = String(value || '').replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  if (d.length > 10 && d[0] === '1') d = d.slice(1);
  return d.slice(0, 10);
};

export const formatPhone = (value) => {
  const d = phoneDigitsOnly(value);
  if (!d) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
